module.exports = __webpack_public_path__ + "static/media/Preview_Black.e7672427.png";